module.exports = __webpack_public_path__ + "static/media/io.23eab627.svg";